import React from 'react';
import { Button } from '@/components/ui/button';
import { KeenIcon } from '@/components/keenicons';
import { FormattedMessage } from 'react-intl';

const AgentUpgradeBox = () => (
  <div className="flex flex-col items-center gap-2 mt-14">
    <div className='flex flex-row justify-center items-center gap-2'>
      <KeenIcon icon="lock" className="text-4xl text-yellow-500 mb-2" />
      <div className="text-xl font-bold text-red-600 text-center">
        <FormattedMessage id="AGENTS.HOME.ACCOUNT_NOT_ALLOWED" />
      </div>
    </div>
    <div className="text-gray-600 text-center text-sm">
      <FormattedMessage id="AGENTS.HOME.UPGRADE_REQUIRED" />
    </div>
    <Button className="bg-[#00B14F]">
      <KeenIcon icon="wallet" className="me-1" />
      <FormattedMessage id="AGENTS.HOME.UPGRADE" />
    </Button>
  </div>
);

export { AgentUpgradeBox }; 